import React, { useState, useEffect } from "react";
import {
  createTwister,
  updateTwister
} from "./adminTongueTwisterService";

const TongueTwisterForm = ({ data, onSaved, onCancel }) => {

  const [form, setForm] = useState({
    title: data?.title || "",
    slug: data?.slug || "",
    description: data?.description || "",
    twisterText: data?.twisterText || "",
    difficultyLevel: data?.difficultyLevel || "EASY",
    language: data?.language || "EN",
    repetitionCount: data?.repetitionCount || 1,
    videoLink: data?.videoLink || ""
  });

  const [loading, setLoading] = useState(false);

  // ✅ Slug generator
  const generateSlug = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")        // spaces → dash
      .replace(/[^a-z0-9-]/g, "")  // remove special chars
      .replace(/-+/g, "-");        // remove duplicate dashes
  };

  // ✅ Auto-generate slug from title (only in CREATE mode)
  useEffect(() => {
    if (!data) {
      const newSlug = generateSlug(form.title);
      console.log("Auto-generating slug:", newSlug);

      setForm(prev => ({
        ...prev,
        slug: newSlug
      }));
    }
  }, [form.title]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: name === "repetitionCount"
        ? parseInt(value || 1)
        : value
    }));
  };

  const save = async () => {

    console.log("==== FORM SUBMIT START ====");
    console.log("Mode:", data ? "UPDATE" : "CREATE");

    // Validation
    if (!form.title || !form.slug || !form.twisterText) {
      console.warn("Validation Failed:", form);
      alert("Required fields missing");
      return;
    }

    // ✅ Clean slug before sending
    const cleanedSlug = generateSlug(form.slug);

    console.log("Original Slug:", form.slug);
    console.log("Cleaned Slug:", cleanedSlug);

    // ✅ Slug validation
    if (!/^[a-z0-9-]+$/.test(cleanedSlug)) {
      alert("Invalid slug format. Use lowercase letters, numbers, and hyphens only.");
      return;
    }

    // Prepare payload
    const payload = {
      ...form,
      slug: cleanedSlug,
      difficultyLevel: form.difficultyLevel?.toUpperCase(),
      repetitionCount: Number(form.repetitionCount)
    };

    console.log("Request Payload:", payload);

    setLoading(true);

    try {

      let res;

      if (data) {
        console.log("Calling UPDATE API with ID:", data.id);
        res = await updateTwister(data.id, payload);
      } else {
        console.log("Calling CREATE API");
        res = await createTwister(payload);
      }

      console.log("API Response:", res);

      if (res.status === 200 || res.status === 201) {
        console.log("SUCCESS ✅");
        onSaved();
      } else {
        console.error("API Error ❌:", res);
        alert(res.message || "Something went wrong");
      }

    } catch (err) {

      console.error("UNEXPECTED ERROR ❌:", err);

      const errorMessage =
        err?.response?.data?.message ||
        JSON.stringify(err?.response?.data) ||
        err.message ||
        "Unknown error";

      console.error("Parsed Error:", errorMessage);

      alert(errorMessage);

    } finally {
      setLoading(false);
      console.log("==== FORM SUBMIT END ====");
    }
  };

  return (

    <div className="form-card">

      <h2>{data ? "Edit" : "Create"} Tongue Twister</h2>

      <div className="form-group">
        <label>Title *</label>
        <input name="title" value={form.title} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label>Slug *</label>
        <input name="slug" value={form.slug} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label>Description</label>
        <textarea name="description" value={form.description} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label>Twister Text *</label>
        <textarea name="twisterText" value={form.twisterText} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label>Difficulty</label>
        <select name="difficultyLevel" value={form.difficultyLevel} onChange={handleChange}>
          <option value="EASY">EASY</option>
          <option value="MEDIUM">MEDIUM</option>
          <option value="HARD">HARD</option>
        </select>
      </div>

      <div className="form-group">
        <label>Language</label>
        <input name="language" value={form.language} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label>Repetition Count</label>
        <input
          type="number"
          name="repetitionCount"
          value={form.repetitionCount}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>YouTube Link</label>
        <input name="videoLink" value={form.videoLink} onChange={handleChange} />
      </div>

      <div className="form-actions">
        <button onClick={save} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>

        <button onClick={onCancel}>Cancel</button>
      </div>

    </div>
  );
};

export default TongueTwisterForm;